import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "submitButton"]

  connect() {
    console.log("AI Select controller connected")
  }

  async submit(event) {
    event.preventDefault()
    
    const form = this.formTarget
    const formData = new FormData(form)
    
    // Disable the submit button and show loading state (if present)
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = true
      this.submitButtonTarget.textContent = "Selecting..."
    }
    
    try {
      const response = await fetch(form.action, {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json'
        }
      })
      
      if (response.ok) {
        const data = await response.json()
        console.log('AI selection result:', data)
        
        // Close the modal
        const modal = this.element.closest('[data-controller="modal"]')
        if (modal) {
          const modalController = this.application.getControllerForElementAndIdentifier(modal, 'modal')
          if (modalController) {
            modalController.close()
          }
        }
        
        // Apply the selection to the table
        this.applySelection(data.selected_ids)
        
      } else {
        throw new Error('Network response was not ok')
      }
    } catch (error) {
      console.error('Error:', error)
      alert('An error occurred while processing your request')
    } finally {
      // Re-enable the submit button and restore original text
      if (this.hasSubmitButtonTarget) {
        this.submitButtonTarget.disabled = false
        this.submitButtonTarget.textContent = "Select with AI"
      }
    }
  }
  
  applySelection(selectedIds) {
    // Find the process table or tasks table controller
    const processTable = document.querySelector('[data-controller*="process-table"]')
    const tasksTable = document.querySelector('[data-controller*="tasks-table"]')
    
    if (processTable) {
      const controller = this.application.getControllerForElementAndIdentifier(processTable, 'process-table')
      if (controller && controller.tabulatorTable) {
        this.selectRowsInTable(controller.tabulatorTable, selectedIds, ['reference', 'id'], controller)
      }
    } else if (tasksTable) {
      const controller = this.application.getControllerForElementAndIdentifier(tasksTable, 'tasks-table')
      console.log(controller)
      if (controller && controller.tabulatorTable) {
        this.selectRowsInTable(controller.tabulatorTable, selectedIds, ['reference', 'id'], controller)
      }
    }
  }
  
  // idFields: the row fields an id may name. controller: the table's, whose
  // recordRows() lists every record of a grouped list, members of closed
  // groups included (the table's own getRows() is only the top level there).
  selectRowsInTable(table, selectedIds, idFields, controller) {
    try {
      // First, clear the selection with the proper method
      table.deselectRow()
      
      // Convert selectedIds to strings for comparison
      const selectedIdStrings = selectedIds.map(id => String(id))
      
      // Get all records and select the ones that match
      const allRows = controller?.recordRows ? controller.recordRows() : table.getRows()
      const rowsToSelect = allRows.filter(row => {
        const rowData = row.getData()
        return idFields.some(field => selectedIdStrings.includes(String(rowData[field])))
      })
      
      // Select the matching rows, and open the group of a member that was
      // hidden so a selected row is one the person can see
      rowsToSelect.forEach(row => {
        const parent = row.getTreeParent?.()
        if (parent && !parent.isTreeExpanded?.()) parent.treeExpand()
        row.select()
      })

      // Clean up modal dialog
      const modalDialog = document.querySelector('#modal dialog');
      if (modalDialog) {
        modalDialog.remove();
      }
      
      console.log(`Selected ${rowsToSelect.length} rows based on AI selection`)
    } catch (error) {
      console.error('Error selecting rows:', error)
      // Fallback: just log the selection
      console.log(`AI selected ${selectedIds.length} items: ${selectedIds.join(', ')}`)
    }
  }
}
